'use strict';

var styled = require('styled-components');
var index = require('../../Flex/index.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const POPIN_MAX_WIDTH_PX = 360;
const POPIN_MAX_HEIGHT_PX = 480;
const ContainerStyled = styled__default.default.div `
  position: absolute;
  top: ${({ $top }) => `${$top || 0}px`};
  left: ${({ $left }) => `${$left || 0}px`};
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
  line-height: 1.5rem;
  box-sizing: border-box;
  width: ${({ $width }) => $width || `${POPIN_MAX_WIDTH_PX}px`};
  max-width: ${POPIN_MAX_WIDTH_PX}px;
  max-height: ${POPIN_MAX_HEIGHT_PX}px;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.colors.body.background};
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
  box-shadow: ${({ theme }) => theme.shadows.default};
  border-radius: ${({ theme }) => theme.radiuses.m};
  z-index: ${({ theme }) => theme.zIndices.tableFilter};
`;
const ContainerPillStyled = styled__default.default(ContainerStyled) `
  box-sizing: initial;
`;
const FilterTitle = styled__default.default.div `
  margin-bottom: 1rem;
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
`;
const FilterDiv = styled__default.default.div `
  margin-top: ${({ iFirstElement }) => (iFirstElement ? 0 : '1.5rem')};
  margin-bottom: 1rem;
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
`;
const FlexDiv = styled__default.default.div `
  display: flex;
  align-items: center;
  margin-top: 8px;
`;
const FlexDivRadio = styled__default.default(FlexDiv) `
  align-items: center;
`;
const FlexDivCheckbox = styled__default.default(FlexDiv) `
  align-items: center;
`;
const FlexDivPill = styled__default.default(FlexDiv) `
  gap: 1rem;
  flex-wrap: wrap;
  max-width: 300px;
  width: max-content;
  box-sizing: border-box;
`;
const FlexDivAll = styled__default.default(FlexDiv) `
  padding-bottom: 0.6875rem;
  position: relative;

  &:after {
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    content: '';
    width: 0.9375rem;
    position: absolute;
    bottom: 0;
    left: 0.125rem;
  }
`;
const Checkbox = styled__default.default.input.attrs({ type: 'checkbox' }) `
  margin: -2px 8px 0 0;
`;
const Radio = styled__default.default.input.attrs({ type: 'radio' }) `
  margin: -2px 8px 0 0;
`;
const RowStyled = styled__default.default(index.Flex.Row) `
  margin-top: 1.25rem;
`;
const LabelStyled = styled__default.default.label `
  margin: 0;
  display: inline;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const CheckboxPillLabelContainerStyled = styled__default.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
`;

exports.Checkbox = Checkbox;
exports.CheckboxPillLabelContainerStyled = CheckboxPillLabelContainerStyled;
exports.ContainerPillStyled = ContainerPillStyled;
exports.ContainerStyled = ContainerStyled;
exports.FilterDiv = FilterDiv;
exports.FilterTitle = FilterTitle;
exports.FlexDiv = FlexDiv;
exports.FlexDivAll = FlexDivAll;
exports.FlexDivCheckbox = FlexDivCheckbox;
exports.FlexDivPill = FlexDivPill;
exports.FlexDivRadio = FlexDivRadio;
exports.LabelStyled = LabelStyled;
exports.POPIN_MAX_HEIGHT_PX = POPIN_MAX_HEIGHT_PX;
exports.POPIN_MAX_WIDTH_PX = POPIN_MAX_WIDTH_PX;
exports.Radio = Radio;
exports.RowStyled = RowStyled;
//# sourceMappingURL=filterPopin.styles.js.map
